import React from 'react'
import Observer from 'react-intersection-observer'
import styles from './PlaylistPageView.module.css'
import Loading from '../Loading/Loading'
import CollectionItem from '../CollectionItem/CollectionItem'

const PlaylistViewContent = ({
  data,
  title,
  searchView,
  allowSeeAll,
  handleViewAll,
  completed,
  fetchNextData,
  handleSelectChannel,
  maxItemsPerRow,
  noDataMessage
}) => {
  const generateDataItems = () => {
    const results = []

    data.forEach((item, key) => {
      results.push(
        <CollectionItem
          onChannelClick={handleSelectChannel}
          index={item.id}
          key={key}
          data={item}
        />
      )
    })

    for (let i = 1; i <= maxItemsPerRow - (data.length % maxItemsPerRow); i++) {
      results.push(<CollectionItem empty={true} key={`empty_${i}`} />)
    }

    return results
  }
  return (
    <>
      <div className={styles['title-wrapper']}>
        <h1>{title}</h1>
        {!!searchView && allowSeeAll && <p onClick={handleViewAll}>See all</p>}
      </div>

      <div className={styles['collection']}>
        <div className={styles['list-container']}>{generateDataItems()}</div>
        {!searchView && completed && !data.length && (
          <div className={styles['no-data']}>
            {noDataMessage || 'No data'}
          </div>
        )}
        {!searchView && !completed && (
          <div className={styles['loader-wrapper']}>
            <Observer
              onChange={inView => {
                inView && data.length && fetchNextData()
              }}
            >
              <Loading height='100px' />
            </Observer>
          </div>
        )}
      </div>
    </>
  )
}

export default PlaylistViewContent
